import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import React from 'react'
import styled from 'styled-components'

import listCovid from './daten-abwasser-covid.json'
import listInfluenza from './daten-abwasser-influenza.json'
import listRSV from './daten-abwasser-rsv.json'

import { index } from 'd3'
import { Button } from 'components/Button'

const allLists: {
  [key: string]: {
    id: number
    name_de: string
    name_fr: string
    dw_id_de: string
    dw_id_fr: string
  }[]
} = {
  covid: listCovid,
  influenza: listInfluenza,
  rsv: listRSV,
}

const Wrapper = styled.div`
  position: relative;
`

const List = styled.div`
  font-family: var(--font-sans-serif);
  display: flex;
  gap: 10px;
  margin-top: 15px;
  margin-bottom: 1em;
  flex-wrap: wrap;
`

const GraphicTitle = styled.h4`
  font-family: var(--font-sans-serif);
  font-size: 18px;
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 15px;
`

// const Element = styled.div<{
//   selected: boolean
//   colorMode: 'dark' | 'light' | undefined
// }>`
//   :hover {
//     color: rgb(204, 204, 204);
//   }
//   position: relative;
//   display: flex;
//   -webkit-box-align: center;
//   align-items: center;
//   -webkit-box-pack: center;
//   justify-content: center;
//   font-family: var(--ui-font-stack);
//   font-weight: 400;
//   font-size: 15px;
//   text-align: center;
//   outline: none;
//   cursor: pointer;
//   padding: 0em 0.5em;
//   min-width: 50px;
//   height: 30px;
//   margin-bottom: -1px;
//   background-color: ${(props) =>
//     props.selected && props.colorMode === 'dark'
//       ? '#ffe462'
//       : !props.selected && props.colorMode === 'dark'
//       ? '#6f7187'
//       : props.selected
//       ? '#202346'
//       : '#efece0'};
//   color: ${(props) =>
//     props.selected && props.colorMode === 'dark'
//       ? '#202346'
//       : !props.selected && props.colorMode === 'dark'
//       ? '#fff'
//       : props.selected
//       ? '#fff'
//       : '#202346'};
// `

function ChartSelector({
  colorMode,
  lang,
  title,
  data,
  setSelected,
  selected,
}: {
  colorMode: 'dark' | 'light' | undefined
  lang: 'de' | 'fr'
  title?: string
  data: string
  setSelected: (s: string) => void
  selected: string
}) {
  // const [selected, setSelected] = React.useState(
  //   lang === 'fr' ? 'Werdhölzli (ZH) FR' : 'Werdhölzli (ZH)'
  // )
  const currentList = allLists[data]
  if (!currentList) return <></>
  const currentElement: any = allLists[data].find(
    (c: any) => c['name_' + lang] === selected
  )
  return (
    <Wrapper>
      {title && <GraphicTitle>{title}</GraphicTitle>}
      <List>
        {allLists[data].map((c: any, index) => (
          <>
            <Button
              selected={c['name_' + lang] === selected}
              onClick={() => setSelected(c['name_' + lang])}
              key={index}
              colorMode={colorMode}
            >
              {c['name_' + lang]}
            </Button>
          </>
        ))}
      </List>
      {currentElement && (
        <AutofitIFrame
          key={(colorMode || 'light') + index}
          src={
            'https://datawrapper.dwcdn.net/' +
            currentElement['dw_id_' + lang] +
            '/?transparent=true&a=' +
            Math.random()
          }
        />
        // <AutofitIFrame
        //   key={(colorMode || 'light') + index}
        //   src={
        //     'https://datawrapper.dwcdn.net/' +
        //     currentElement['dw_id_' + lang] +
        //     '/?dark=' +
        //     String(colorMode === 'dark') +
        //     '&transparent=true&a='+Math.random()
        //   }
        // />
      )}
    </Wrapper>
  )
}

export default ChartSelector
